export default __webpack_public_path__ + "static/media/Phone.61541633.png";